exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gridQuota {\n    height: 240px;\n}\n\n@media only screen and (max-width: 1024px) {\n    .gridQuota {\n        height: 340px;\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .gridQuota {\n        height: 350px;\n    }\n}\n\n@media only screen and (max-width: 425px) {\n    .gridQuota {\n        height: 350px;\n    }\n}\n\n@media only screen and (max-width: 375px) {\n    .gridQuota {\n        height: auto;\n    }\n}\n\n@media only screen and (max-width: 320px) {\n    .gridQuota {\n        height: auto;\n    }\n}\n", ""]);

// exports
